<app-shared-dialog [title]="'inventory.product_details.title' | translate" 
    [options]="{ 
      cancelText: ('inventory.product_details.close' | translate), 
      cancelButtonStyle: 'secondary-btn', 
      size: 'large', 
      hideConfirmButton: true 
    }" (cancel)="cancel()">
  <div class="product-details-dialog">
    <div class="product-content-container">
      <div class="product-content">

        <!-- Left: Product images -->
        <div class="image-section">
          <div class="main-image">
            <img [src]="product.image || 'assets/images/default-product.png'" alt="{{ product.name }}" />
          </div>

          <div class="thumbnails" *ngIf="allImages.length > 1">
            <button class="nav-btn" (click)="prevImage()">
              <img src="assets/icones/arrow-select-left.svg" alt="Prev" />
            </button>

            <div class="thumbs">
              <img *ngFor="let img of allImages; let i = index" [src]="img" [class.active]="i === currentImage"
                (click)="selectImage(i)" alt="Thumbnail" />
            </div>

            <button class="nav-btn" (click)="nextImage()">
              <img src="assets/icones/arrow-select-right.svg" alt="Next" />
            </button>
          </div>
        </div>

        <!-- Right: Product info -->
        <div class="info-section">
          <h2 class="product-title">{{ product.name }}</h2>

          <div class="info-grid">
            <div class="label">{{ 'inventory.product_details.brand' | translate }}</div>
            <div class="value">{{ product.brand?.name || '--' }}</div>

            <div class="label">{{ 'inventory.product_details.description' | translate }}</div>
            <div class="detail-value">
              <div #descriptionText class="description-text" [class.expanded]="isDescriptionExpanded"
                [innerHTML]="product?.description || '--'">
              </div>

              <button *ngIf="shouldShowToggle && hasDescription" class="show-more-btn" (click)="toggleDescription()">
                {{ isDescriptionExpanded ? ('inventory.product_details.show_less' | translate) :
                ('inventory.product_details.show_more' |
                translate) }}
              </button>
            </div>

            <div class="label">{{ 'inventory.product_details.labels' | translate }}</div>
            <div class="value tags">
              <span *ngFor="let label of product.tags" class="tag">
                {{ label.name }}
              </span>
            </div>

            <div class="label">{{ 'inventory.product_details.categories' | translate }}</div>
            <div class="value tags">
              <span *ngFor="let category of product.categories" class="tag neutral">
                {{ category.name }}
              </span>
            </div>

            <hr class="divider" />

            <ng-container *ngIf="!isVariant">
              <div class="label">{{ 'inventory.product_details.ean' | translate }}</div>
              <div class="value">{{ product.barcode || '--' }}</div>
  
              <div class="label">{{ 'inventory.product_details.sku' | translate }}</div>
              <div class="value">{{ product.sku || '--' }}</div>

              <div class="label">{{ 'inventory.product_details.stock' | translate }}</div>
              <div class="value">
                <ng-container *ngIf="product.stock?.quantity != null; else noStock">
                  {{ product.stock?.quantity }} {{ 'inventory.product_details.units' | translate }}
                </ng-container>
                <ng-template #noStock>--</ng-template>
              </div>
            

              <hr class="divider" />

              <div class="label">{{ 'inventory.product_details.min_order_qty' | translate }}</div>
              <div class="value">{{ product.variants?.[0]?.min_qte || '--' }}</div>

              <div class="label">{{ 'inventory.product_details.increase' | translate }}</div>
              <div class="value">{{ product.variants?.[0]?.increment || '--' }}</div>

              <div class="label">{{ 'inventory.product_details.max_order_qty' | translate }}</div>
              <div class="value">{{ product.variants?.[0]?.max_qte || '--' }}</div>

              <hr class="divider" />

              <div class="label">{{ 'inventory.product_details.mrsp' | translate }}</div>
              <div class="value">
                <ng-container *ngIf="product.final_price != null; else noFinalPrice">
                  {{ product.final_price }} {{ getCurrencySymbol() }}
                </ng-container>
                <ng-template #noFinalPrice>--</ng-template>
              </div>

              <div class="label">{{ 'inventory.product_details.unit_price' | translate }}</div>
              <div class="value">
                {{product.sales_price ? (product.sales_price | number:'1.2-2')+ ' ' + getCurrencySymbol() : '--' }}
              </div>

              <div class="label">{{ 'inventory.product_details.discount_on_mrsp' | translate }}</div>
              <div class="value">
                <ng-container *ngIf="product.discount != null; else noDiscount">
                  {{ product.discount }} {{ getCurrencySymbol() }}
                </ng-container>
                <ng-template #noDiscount>--</ng-template>
              </div>

              <hr class="divider" />
            </ng-container>
            <div class="label">{{ 'inventory.product_details.documents' | translate }}</div>
            <div class="value">
              <ng-container *ngFor="let file of product.files">
                <a [href]="file.data" [attr.download]="file.filename" target="_blank" class="doc-link">
                  <img src="assets/icones/file-product.svg" alt="File" />
                  {{ file.filename }}
                </a>
              </ng-container>
              <span *ngIf="!product.files?.length">--</span>
            </div>
          </div>
        </div>
      </div>
      <!-- variants -->
      <div class="variant-section" *ngIf="isVariant">
        <div class="variants-container">
          <table class="variants-table">
              <thead>
                <tr class="row header">
                  <th>
                    {{'inventory.img' | translate}}
                  </th>
                  <th>
                    Variant
                  </th>
                  <th>{{"common.retail_price" | translate}}</th>
                  <th>{{"common.price" | translate}}</th>
                  <th>{{"inventory.stock" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                  <ng-container *ngFor="let variant of data.variants; let i = index">
                    <tr class="row body">
                      <td>
                        <img class="variant-image" [src]="getImageUrl(variant.image!) || 'assets/images/no-img.svg'" />
                      </td>   
                      <td>
                        <div class="variant-name">
                          <div class="tags-container">
                            <span class="tag" *ngFor="let value of variant.values">
                              {{value}}
                            </span>
                          </div>
                        </div>
                      </td> 
                      <td>
                          {{ variant.sales_price ? variant.sales_price + ' ' + getCurrencySymbol() : '--' }}
                      </td>          
                      <td>
                          {{ variant.cost ? variant.cost + ' ' + getCurrencySymbol() : '--' }}
                      </td>
                      <td>
                          {{ variant.stock?.quantity }} {{ 'inventory.product_details.units' | translate }}
                      </td>
                    </tr>
                  </ng-container>
              </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>
</app-shared-dialog>
